export default async function (action, args) {
    console.log('cart-rule-action:remove_coupon', { action, args })

    const store = window.addiesaas.store

    const discounts = Object.values(store.getters['Shop/Orders/Cart/cartDiscounts'])
    const couponDiscount = discounts.find(discount => discount.type == 'coupon' && discount.payload.options.code == action.code)

    if (couponDiscount) {
        await store.dispatch('Shop/Orders/Cart/removeCartDiscount', { id: couponDiscount.id })

        window.addiesaas.$core.EventBus.$emit('cart.validate')
    }
}
